var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nk-block-head nk-block-head-sm sip-page-intro" },
    [
      _c("div", { staticClass: "nk-block-between sip-page-intro__row" }, [
        _c(
          "div",
          { staticClass: "nk-block-head-content sip-page-intro__copy" },
          [
            _vm.hasMeta
              ? _c(
                  "nav",
                  {
                    staticClass: "sip-page-intro__meta",
                    attrs: { "aria-label": "Breadcrumb" },
                  },
                  [
                    _vm.hasBadge
                      ? _c(
                          "span",
                          {
                            staticClass: "sip-page-intro__badge",
                            class: "sip-page-intro__badge--" + _vm.badgeTone,
                          },
                          [
                            _vm.livePulse
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "sip-page-intro__pulse",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "sip-page-intro__pulse-ping",
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "sip-page-intro__pulse-dot",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.badgeText))]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasBadge && _vm.crumbs.length
                      ? _c(
                          "span",
                          {
                            staticClass: "sip-page-intro__meta-sep",
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("·")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.crumbs.length
                      ? _c(
                          "ol",
                          { staticClass: "sip-page-intro__crumbs" },
                          [
                            _vm._l(_vm.crumbs, function (crumb, index) {
                              return [
                                index > 0
                                  ? _c(
                                      "li",
                                      {
                                        key: "sep-" + index,
                                        staticClass:
                                          "sip-page-intro__crumb-sep",
                                        attrs: { "aria-hidden": "true" },
                                      },
                                      [_vm._v("/")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  { key: "crumb-" + index },
                                  [
                                    crumb.to && index < _vm.crumbs.length - 1
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "sip-page-intro__crumb-link",
                                            attrs: { to: crumb.to },
                                          },
                                          [_vm._v(_vm._s(crumb.label))]
                                        )
                                      : crumb.href &&
                                        index < _vm.crumbs.length - 1
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "sip-page-intro__crumb-link",
                                            attrs: { href: crumb.href },
                                          },
                                          [_vm._v(_vm._s(crumb.label))]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "sip-page-intro__crumb-current",
                                          },
                                          [_vm._v(_vm._s(crumb.label))]
                                        ),
                                  ],
                                  1
                                ),
                              ]
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasTitle
              ? _c(
                  "h3",
                  {
                    staticClass:
                      "nk-block-title page-title sip-page-intro__title",
                  },
                  [_vm._v(_vm._s(_vm.title))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasSubtitle
              ? _c("p", { staticClass: "sip-page-intro__subtitle" }, [
                  _vm._v(_vm._s(_vm.subtitle)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.hasDescription
              ? _c(
                  "div",
                  { staticClass: "nk-block-des text-soft sip-page-intro__des" },
                  [
                    _vm._t("description", function () {
                      return [
                        _vm.description
                          ? _c("p", [_vm._v(_vm._s(_vm.description))])
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.hasActions
          ? _c(
              "div",
              { staticClass: "nk-block-head-content sip-page-intro__actions" },
              [
                _vm._t("actions", function () {
                  return [_vm._t("default")]
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }